module.exports = __webpack_public_path__ + "static/media/btn-top.bbb4a121.svg";